import { render, staticRenderFns } from "./ColorModuleFilters.vue?vue&type=template&id=15ce26b0&scoped=true"
import script from "./ColorModuleFilters.vue?vue&type=script&lang=ts"
export * from "./ColorModuleFilters.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleFilters.vue?vue&type=style&index=0&id=15ce26b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ce26b0",
  null
  
)

export default component.exports